import { action, makeObservable, observable, runInAction } from "mobx";
import { TableStore } from "../TableStore";
import { ColumnsType, DataState, MULTIPLE } from "../types";
import { BaseRowStore } from "../row/BaseRowStore";
import { BaseColumn } from "./BaseColumn";
import { _ } from "ynf-core-middleware";

type ReturnInfo = {
  storeKey: string
  realKey: string
  key: string
}

type ReturnArr = ReturnInfo[]

export class ReferColumn extends BaseColumn {
  refReturnArr: any = {};
  returnArr: ReturnArr;
  refReturn: any = [];
  // 选择类型，多选参照使用
  selectType?: string;
  dataSourceAlias?: string;
  characterEffects?: string[];
  // 数据库查询回来的数据，用于处理 数据的 delete update insert  等标识
  multipleData: any = [];
  // 是否是第一次设置值
  isFirstSetValue: boolean = true;
  constructor(column: ColumnsType, tableStore: TableStore) {
    super(column, tableStore);
    this.refReturnArr = {};
    this.returnArr = [];
    this.selectType = column.selectType;
    this.dataSourceAlias = column.dataSourceAlias;
    makeObservable(this, {
      refReturnArr: observable,
      setValue: action,
      getValue: action
    });
    if (column.refReturnArr) {
      this.refReturnArr = JSON.parse(column.refReturnArr);
      // 兼容一个值带入多个字段字段间用;分割的场景
      this.returnArr = this.adaptRefReturnArr(this.refReturnArr)
    }
    if (column.refReturn) {
      this.refReturn = column.refReturn;
    }
    if (column.characterEffects) {
      // 关联的特征组字段
      this.characterEffects = column.characterEffects;
      if (!this.tableStore.characterEffects) {
        this.tableStore.characterEffects = {};
      }
      this.tableStore.characterEffects[this.storeAlias] = this.characterEffects;
    }
    this.addCharacterFields()
  }

  private addCharacterFields() {
    if (this.isCharacter()) {
      this.returnArr?.forEach((item: any) => {
        const storeAlias = item.realKey
        this.tableStore?.addColumns?.({ ...item, storeAlias, stateType: 'character'})
      })
    }
  }

  /**
   * 兼容参照refReturnArr一个值带入多个字段字段间用;分割的场景
   */
  adaptRefReturnArr = (refReturnArr: any) => {
    const returnArr: ReturnInfo[] = []
    for (const referStoreAlias in refReturnArr) {
      // 要带入的字段
      const returnField = refReturnArr[referStoreAlias]
      // 要将一个值带入到多个字段, 字段之间用会;分割
      returnField.split(';').forEach((item: any) => {
        const returnFieldArr = item.split(',')
        returnArr.push({
          storeKey: returnFieldArr[0],
          realKey: returnFieldArr[1],
          key: referStoreAlias
        })
      })
    }
    return returnArr
  }

  /**
   *
   * @param item 参照对象转换
   * @returns 真实对象
   */
  changeObj(item: any) {
    const data: any = {};
    for (const returnInfo of this.returnArr) {
      const { realKey, key } = returnInfo
      data[realKey] = item[key];
    }
    // Object.keys(this.refReturnArr).forEach((key) => {
    //   const realKey = this.refReturnArr[key].split(",").pop();
    //   data[realKey] = item[key];
    // });
    return data;
  }

  /**
   * 修改参照处理
   * @param value
   * @param row
   * @returns
   */
  setValue(value: any, row: BaseRowStore<any>) {
    if (typeof value === "string") {
      super.setValue(value, row)
      return;
    }
    // 如果是多选参照。直接存储对象
    if (this.selectType === MULTIPLE) {
      this.setMultipleData(value, row)
      return;
    }
    // 单选参照
    runInAction(() => {
      for (const returnInfo of this.returnArr) {
        const { realKey, key } = returnInfo
        const newkey = this.getFieldByStoreAlias(realKey)
        row.setTrueValue(newkey, value[key]!== undefined ? value[key]: null, this.getColumn(realKey)?.isCharacter());
      }
    });
  }

  setMultipleData(value: any, row: BaseRowStore<any>) {
    // 整理参照带入字段并设置数据到row
    if (!this.dataSourceAlias) {
      throw new Error(`Multiple references must include this 'dataSourceAlias'`)
    }
    const res: any = [];
    value?.forEach((item: any) => {
      const data: any = {};
      for (const returnInfo of this.returnArr) {
        const { realKey, key } = returnInfo
        data[realKey] = item[key];
      }
      res.push(data);
    });
    const multipleReferValue = this.diffUpdate(res, row)
    row.setTrueValue(this.dataSourceAlias, multipleReferValue)
  }
  // 根据行数据差量更新多选参照
  diffUpdate(rows: any, row: BaseRowStore<any>) {
    // 获取旧值
    // @ts-ignore
    const oldMultipleReferValue = row.getTrueValue(this?.dataSourceAlias) || []
    // 更新旧值状态位
    oldMultipleReferValue.forEach((item: any, index: string | number) => {
      const findIndex = rows.findIndex((row: any) =>
        Object.entries(row).every(
          ([key, value]) => item[key] === value
        )
      );
      if (findIndex === -1) {
        // 新值中不存在，旧值中存在
        // 如果是新增态数据，删除
        if (oldMultipleReferValue[index]?._status === DataState.Insert) {
          delete oldMultipleReferValue[index]
        } else {
          // 其他状态的数据，状态位置为'Delete'
          oldMultipleReferValue[index]._status = DataState.Delete
        }
        // delete
      } else {
        // @ts-ignore
        const _status: ROW_STATUS = oldMultipleReferValue[index]._status
        // 新值旧值中都存在, 状态位置为'Update'
        if ([DataState.Unchanged, undefined, DataState.Delete].includes(_status)) {
          oldMultipleReferValue[index]._status = DataState.Update
        }
        rows.splice(findIndex, 1);
      }
    })
    // 插入数据状态位
    rows.forEach((row: any) => row._status = DataState.Insert)
    // 旧数据中已删除数据过滤
    const updatedValue = oldMultipleReferValue.filter((value: any) => value !== undefined)
    return updatedValue.concat(rows)
  }

  /**
   *
   * @param row
   * @param status 只读态 true
   * @returns
   */
  private getRefData(row: BaseRowStore<any>): any {
    const returnArr = this.returnArr
    const selectType = this.selectType
    const dataSourceAlias = this.dataSourceAlias
    if (selectType === MULTIPLE) {
      if (!dataSourceAlias) {
        throw new Error(`Multiple references must include this 'dataSourceAlias'`);
      }
      const data = row.getTrueValue(dataSourceAlias)?.filter(
        (item: any) => item._status !== DataState.Delete
      );
      if (!data) {
        return;
      }
      const refDataArrays: any[] = [];
      data.forEach((item: any) => {
        const refData: any = {};
        for (const returnInfo of returnArr) {
          const { realKey, key } = returnInfo;
          refData[key] = item[realKey];
        }
        refDataArrays.push(refData);
      });
      return refDataArrays;
    } else {
      const refData: any = {};
      for (const returnInfo of returnArr) {
        const { realKey, key } = returnInfo;
        const newkey = this.getFieldByStoreAlias(realKey);
        // realKey == storeAlias newkey == field 当没有配置 field的时候，确保能够正常运行。
        refData[key] = row.getTrueValue(newkey) != undefined ? row.getTrueValue(newkey) : row.getTrueValue(realKey);
      }
      return refData;
    }
  }

  getValue(row: BaseRowStore<any>) {
    return this.getRefData(row);
  }

  get value() {
    return (row: BaseRowStore<any>) => {
      return this.getRefData(row);
    };
  }
}
